import React from 'react'

import * as styles from './Demo.module.scss'

import Footer from 'src/modules/organisms/footer/Footer'
import Layout from 'src/components/partials/Layout'
import SEO from 'src/components/partials/Seo'
import Divider from 'src/modules/molecules/divider'
import { WistiaPlayer } from 'src/modules/molecules/wistia-embed/player'
import ObviousLogo from 'src/modules/molecules/obvious-logo'

const FlatfileLogoWrapper = () => {
  return (
    <div className={styles.thanksHeader}>
      <div className={styles.thanksLogo}>
        <a title='Flatfile.com | Back to top' href='/'>
          <ObviousLogo color='white' />
        </a>
      </div>
    </div>
  )
}

const ThankYouScreen = () => {
  return (
    <div className={styles.thanksWrapper}>
      <div className={styles.thanksContainer}>
        <h1 className='title-h3--alt'>Thank you for requesting a demo</h1>

        <p className='max-w-[580px] mx-auto mt-5 mb-10'>
          We'll be in touch soon.
        </p>

        <div className={styles.thanksVideo}>
          <WistiaPlayer abTest={false} videoId='4gm8qtedon' />
        </div>

        <Divider size='xl' width='12rem' />

        <p className='text-center text-gray-400 mb-8'>
          Powering 3,000+ of the world’s best data migration teams
        </p>

        <img
          className='w-[600px] mx-auto'
          src='/img/demo/demo-logos-2.webp'
          alt='customer logos'
          width='600'
        />
      </div>
    </div>
  )
}

const DemoPage = () => {
  return (
    <Layout>
      <FlatfileLogoWrapper />
      <ThankYouScreen />
      <Footer showCta={false} hideFooterMain />
    </Layout>
  )
}

export default DemoPage

export const Head = () => (
  <SEO
    description={`We'll be in touch soon.`}
    title='Thank you for requesting a demo'
    robots='hide'
  />
)
